"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredData = void 0;
var getFilteredData = function (params) {
    var list = params.list, filters = params.filters, normalizers = params.normalizers, searchFn = params.searchFn;
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (searchFn)
            return list.filter(searchFn);
        return __spreadArray([], list, true);
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var searchValue = filters && typeof filters[key] === 'string'
                ? filters[key].toLowerCase()
                : '';
            var normalizeValueToFilter = getNormalizer(key, normalizers);
            var value = normalizeValueToFilter(item);
            if (searchValue &&
                value.toLowerCase().indexOf(searchValue.toLowerCase()) === -1)
                return result;
        }
        if (searchFn) {
            if (searchFn(item))
                result.push(item);
        }
        else
            result.push(item);
        return result;
    }, []);
    return filtered;
};
exports.getFilteredData = getFilteredData;
var getNormalizer = function (columnIdentifier, normalizers) {
    return function (item) {
        if (normalizers && typeof normalizers[columnIdentifier] === 'function')
            return (normalizers[columnIdentifier](item) || '').toString();
        return (item[columnIdentifier] || '').toString();
    };
};
